import { getTokenFromCookie } from '@/utils/cookies';
import { Router, scrollBehavior } from '@/utils/router.js';
import { setHtmlMeta, hostBuild } from '@/utils/utils';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "core_forsale" */ './home/home.vue'),
      meta: { desc: '首页' },
    },
    {
      path: '/list/:topic',
      name: 'List',
      component: () => import(/* webpackChunkName: "core_forsale" */ './home/home.vue'),
      meta: { desc: '列表页' },
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import(/* webpackChunkName: "core_forsale" */ './search/search.vue'),
      meta: { desc: '搜索页' },
    },
    {
      path: '/detail/:topic/:id',
      name: 'Detail',
      component: () => import(/* webpackChunkName: "core_forsale" */ './detail/detail.vue'),
      meta: { desc: '详情页' },
    },
    {
      path: '/publish',
      name: 'Publish',
      component: () => import(/* webpackChunkName: "core_forsale" */ './publish/publish.vue'),
      meta: { desc: '发布页', isAuth: true },
    },
    {
      path: '/publish/success/:topic/:id',
      name: 'PublishSuccess',
      component: () => import(/* webpackChunkName: "core_forsale" */ './publish-success/publish-success.vue'),
      meta: { desc: '发布成功页' },
    },
    {
      path: '/postlist/:topic',
      name: 'PostList',
      component: () => import(/* webpackChunkName: "core_forsale" */ './post/list.vue'),
      meta: { desc: '帖子列表页' },
    },
    {
      path: '/websafe',
      name: 'WebSafe',
      component: () => import(/* webpackChunkName: "core_forsale" */ '@/common/websafe.vue'),
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: "core_forsale" */ '@/common/404/index.vue'),
      meta: { desc: '404' },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  // 这里只能用本地token进行判断是否登录，否则刷新页面会出现问题
  const token = getTokenFromCookie();
  if (to.meta.isAuth === true && !token) {
    location.replace(hostBuild(`/login?redirect=${location.href}`, 'account'));
    return next(false);
  }

  if (to.name == 'Home') {
    setHtmlMeta({
      title: '多伦多二手 - 约克论坛 - 加拿大第一中文网',
      keywords:
        '多伦多二手,加拿大华人二手买卖,二手服饰,二手母婴,二手电脑手机,二手书本,flea market,toronto forsale,garage sale,yard sale,搬家甩卖,多伦多求购二手,',
      description: '多伦多华人和留学生最常用的二手物品交易平台，提供手机平板、汽车轮胎、母婴用品、家具家电、电脑手机配件、课本门票等，Markham、Richmond Hill、North York、Scarborough、Etobicoke、Mississauga等地闲置物品轻松交易。yorkbbs.ca',
    });
  } else if (to.name == 'Search') {
    setHtmlMeta({
      title: '搜索 - 多伦多二手 - 约克论坛',
      keywords: '',
      description: '',
    });
  } else if (to.name == 'Publish') {
    setHtmlMeta({
      title: '发布信息 - 多伦多二手 - 约克论坛',
      keywords: '',
      description: '',
    });
  } else if (to.name == 'WebSafe') {
    setHtmlMeta({ title: '外链 - 约克论坛', keywords: '', description: '' });
  } else if (to.name == 'NotFound') {
    setHtmlMeta({ title: '404 - 约克论坛', keywords: '', description: '' });
  } else {
    setHtmlMeta({ title: '', keywords: '', description: '' });
  }

  if (to.name == 'NotFound' && !to.query.from) return next({ name: 'NotFound', query: { from: location.href } });

  next();
});

export { router };
